import { type ApolloError } from '@apollo/react-hooks';
import { MONITOR_LIST_TEXT } from '../../../components';
const PROGRAMME_LEVEL = MONITOR_LIST_TEXT.PROGRAMME_LEVEL;

export type DRCApplicationData = {
  applicationId: string;
  applicationNo: string;
  applicantName: string;
  chineseName?: string;
  progLevel: string;
  researchField: string;
  department?: string;
  studyMode: string;
  chiefSupervisor: string;
  fundingScheme: string;
  status: string;
  action: React.ReactNode;
  entryYear: string;
};

export type DRCNonProposedData = {
  applicationId: string;
  applicationNo: string;
  applicantName: string;
  department: string;
  progLevel: string;
  researchField: string;
  studyMode: string;
  inWhichSupervisorList: string;
  programmeType: string;
  HKPFSReferenceNumber: string;
  validHKPFSApplication: boolean | null; // null means validation has not been done yet
  status: string;
  action: React.ReactNode;
  entryYear: string;
  lastNominationSubmissionTime: string;
  fundingScheme?: string[];
};

export type GetApplications = {
  applications: DRCApplicationData[];
  loading: boolean;
  error: ApolloError | undefined;
};

export type ReturnData = {
  _id: string;
  applicationNo: string;
  applicant: {
    name: {
      givenName: string;
      surname: string;
      chineseName: string;
    };
  };
  programmeChoice: {
    programme: string | typeof PROGRAMME_LEVEL;
    researchArea: string;
    proposedChiefSupervisor?: string;
    programmeType?: string;
    studyMode: string;
    entryYear: string;
    department?: string;
  };
  status: string;
};

export type GetNonProposedData = {
  nonProposedApplications: {
    data: DRCNonProposedData[];
    totalPage: number;
    count: number;
  };
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};
